import { render, staticRenderFns } from "./AlertsSummary.vue?vue&type=template&id=79c87be9"
import script from "./AlertsSummary.vue?vue&type=script&lang=js"
export * from "./AlertsSummary.vue?vue&type=script&lang=js"
import style0 from "./AlertsSummary.vue?vue&type=style&index=0&id=79c87be9&prod&lang=css"
import style1 from "./AlertsSummary.vue?vue&type=style&index=1&id=79c87be9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports